import React from "react";

import {
  pickMillions,
  getPerformanceValues,
  getInstructorsDashboardPerformanceColors
} from "components/analysis/utils";
import OnePanelChart from "components/analysis/OnePanelChart";
import Formula from "components/analysis/Formula";
import Text from "components/analysis/Text";

const Revenues = ({ teams, metricsReports, currentGame, roundNumber }) => {
  const chartData = getPerformanceValues(
    pickMillions(teams, metricsReports, "net_revenues")
  );
  const colors = getInstructorsDashboardPerformanceColors(chartData.length);

  return (
    <OnePanelChart
      title="Net Revenues"
      data={chartData}
      customColors={colors}
      showCategoryLabels={true}
      prefix="$"
      suffix="M"
      precision={1}
      instructorData={{ currentGame, roundNumber, type: "revenues" }}
    >
      <Text>
        Revenues are the total dollar sales that a business might generate
        within a period of time. It is calculated by taking the number of units
        sold multiplied by the selling price of each unit:
        <br />
      </Text>
      <Formula>REVENUES = UNIT SALES &#215; UNIT SELLING PRICE</Formula>
    </OnePanelChart>
  );
};

export default Revenues;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard/revenues.js